var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"root"},[_c('header',{staticClass:"mainHeader"},[_c('router-link',{staticClass:"h1",attrs:{"to":{ name: 'Home'},"tag":"h1"}},[_vm._v(" Avant-garde Movement App ")])],1),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }